var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#959595",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3742 10.3115C10.3742 7.37806 12.7523 5 15.6858 5C18.6192 5 20.9973 7.37806 20.9973 10.3115C20.9973 13.245 18.6192 15.6231 15.6858 15.6231C12.7523 15.6231 10.3742 13.245 10.3742 10.3115ZM15.6858 6.87466C13.7876 6.87466 12.2489 8.41341 12.2489 10.3115C12.2489 12.2097 13.7876 13.7484 15.6858 13.7484C17.5839 13.7484 19.1226 12.2097 19.1226 10.3115C19.1226 8.41341 17.5839 6.87466 15.6858 6.87466Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6867 19.3724C9.13364 19.3724 7.87466 20.6314 7.87466 22.1844V23.6695C7.87466 23.6921 7.89105 23.7114 7.91337 23.715C13.0609 24.5554 18.3106 24.5554 23.4581 23.715C23.4805 23.7114 23.4969 23.6921 23.4969 23.6695V22.1844C23.4969 20.6314 22.2379 19.3724 20.6849 19.3724H20.2588C20.2259 19.3724 20.1932 19.3776 20.1619 19.3878L19.0802 19.7411C16.8745 20.4613 14.497 20.4613 12.2913 19.7411L11.2096 19.3878C11.1783 19.3776 11.1456 19.3724 11.1127 19.3724H10.6867ZM6 22.1844C6 19.596 8.09829 17.4978 10.6867 17.4978H11.1127C11.3432 17.4978 11.5724 17.5342 11.7915 17.6058L12.8732 17.959C14.7008 18.5557 16.6707 18.5557 18.4983 17.959L19.58 17.6058C19.7991 17.5342 20.0283 17.4978 20.2588 17.4978H20.6849C23.2732 17.4978 25.3715 19.596 25.3715 22.1844V23.6695C25.3715 24.6109 24.6893 25.4135 23.7602 25.5652C18.4126 26.4383 12.9589 26.4383 7.6113 25.5652C6.68223 25.4135 6 24.6109 6 23.6695V22.1844Z",
    fill: "#959595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLine);
export default __webpack_public_path__ + "static/media/icon_user_line.f8528a50a00f53d9e5e9d2580e993145.svg";
export { ForwardRef as ReactComponent };